import React from 'react';
import {AgentsInvoicesUIProvider} from '../components/AgentsIncomesUIContext';
import {AgentsIncomesLoadingDialog} from '../components/agents-incomes-loading-dialog/AgentsIncomesLoadingDialog';
import {AgentsIncomesCard} from './AgentsIncomesCard';

export function AgentsIncomesPage() {
  const invoicesUIEvents = {};

  return (
    <AgentsInvoicesUIProvider invoicesUIEvents={invoicesUIEvents}>
      <AgentsIncomesLoadingDialog/>
      <AgentsIncomesCard/>
    </AgentsInvoicesUIProvider>
  );
}
